import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Link from '@mui/material/Link';
import SimpleModal from 'common/components/Elements/Modal/SimpleModal/SimpleModal';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import theme, { createStyles,ThemeColors } from 'core/utilities/theme';
import React from 'react';
import { useSelector } from 'react-redux';

const classes = createStyles({
  preview: {
    position: 'relative', // Needed for the element to be on top of buttons on hover
    display: 'inline-block',
    margin: '1px 1px 0 0', // Used to separate multiple images next to each other
    padding: theme.spacing(0.5),
    cursor: 'zoom-in',
    '& img': {
      maxHeight: '140px',
    },
    '&:hover': {
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
      zIndex: 1299, // below modal
      background: '#ffffff',
      transform: 'scale(2.5)',
    },
  },
  previewInTable: {
    position: 'relative', // Needed for the element to be on top of buttons on hover
    display: 'inline-block',
    margin: '1px 1px 0 0', // Used to separate multiple images next to each other
    padding: theme.spacing(0.5),
    cursor: 'zoom-in',
    border: `1px solid ${ThemeColors.tableBorder}`,
    verticalAlign: 'middle',
    textAlign: 'center',
    '& img': {
      maxHeight: '70px',
    },
  },
  modal: {
    maxHeight: '75vh',
    maxWidth: '90vw',
    margin: '0 auto',
    border: 0,
  },
  button: {
    display: 'inline-block',
  },
});

export interface ComponentProps {
  imgUrl: string;
  linkUrl?: string;
  title?: string;
  inTable?: boolean;
  onlyImgTag?: boolean;
}

function Image({
  imgUrl, linkUrl, title, inTable, onlyImgTag,
}: ComponentProps) {
  const jsfUrl = useSelector((state: ApplicationState) => state.configuration.jsfUrl);
  // In some cases, the value might not only contain a path but a full URL
  const formattedImgUrl = `${(imgUrl).startsWith('http') ? '' : jsfUrl}${imgUrl}`;

  if (onlyImgTag) {
    return (<img alt={title} src={formattedImgUrl} />);
  }

  const Img = (
    <Box sx={inTable ? classes.previewInTable : classes.preview}>
      <img alt={title} src={formattedImgUrl} />
    </Box>
  );

  return (
    <Box display={inTable ? 'inline-block' : 'block'}>
      {linkUrl && (
        <Link
          href={`${(linkUrl).startsWith('http') ? '' : jsfUrl}${linkUrl}`}
          target="_blank"
        >
          {Img}
        </Link>
      )}
      {!linkUrl && (
        <SimpleModal
          title=""
          size="auto"
          // eslint-disable-next-line react/no-unstable-nested-components
          trigger={(onClick) => (
            <ButtonBase onClick={onClick} sx={classes.button}>
              {Img}
            </ButtonBase>
          )}
          content={(
            <Box
              component="img"
              alt={title}
              src={formattedImgUrl}
              sx={classes.modal}
            />
          )}
        />
      )}
    </Box>
  );
}

export default Image;
